import { Spinner } from "@fluentui/react-components";
import { useParams } from "react-router-dom";

import { ErrorState } from "@/components/ErrorState";
import { ReviewLayout } from "@/features/review/ReviewLayout";
import { useDocumentDetail } from "@/features/review/useDocumentDetail";

export function Review() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, isError, error } = useDocumentDetail(id);

  if (!id) {
    return <ErrorState title="Missing document id" message="No id in URL." />;
  }
  if (isLoading) {
    return (
      <div style={{ padding: 48, textAlign: "center" }}>
        <Spinner label="Loading document…" />
      </div>
    );
  }
  if (isError || !data) {
    return (
      <ErrorState
        title="Failed to load document"
        message={error instanceof Error ? error.message : "Unknown error"}
      />
    );
  }
  return <ReviewLayout detail={data} />;
}
